'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addMonths;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addMonths.js
// module id = 471
// module chunks = 0